import { NavLink } from "react-router-dom";
import Image from "react-bootstrap/Image";
import LogOutButtonWithConfirmModal from "../LogOutButtonWithConfirmModal";
import NotificationsButtonWithModal from "../NotificationsButtonWithModal";
import { useAuthStore } from "../../store/store";

export default function ListenerNav() {
    const user = useAuthStore(state => state.user);

    return (
        <nav className="navbar navbar-expand-md navbar-light border-bottom">
            <div className="container">
                <NavLink to="/" className="navbar-brand">
                    <Image src="/img/podsy-logo-w-200.png" fluid className={"w-50"} />
                </NavLink>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#topnav">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div id="topnav" className="collapse navbar-collapse">
                    <ul className="navbar-nav ms-auto mb-2 mb-md-0">
                        <li className="nav-item">
                            <NavLink to="/listener-dashboard" className={({isActive}) => "nav-link" + (isActive ? " active" : "")} end>Dashboard</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/listener-clubs" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>Clubs to join</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/listener-practices" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>Practices</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/profile" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>Profile</NavLink>
                        </li>
                        {user?.is_admin && (
                            <li className="nav-item">
                                <NavLink to="/admin" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>Admin</NavLink>
                            </li>
                        )}
                        <li>
                            &nbsp;
                        </li>
                        <li className="nav-item px-2">
                            <NotificationsButtonWithModal
                                className="nav-link"
                                tooltip_position={'bottom'}
                            />
                        </li>
                        <li className="nav-item px-2">
                            <LogOutButtonWithConfirmModal
                                tooltip_position={'bottom'}
                                // displayButtonText={'Log out'}
                                className="nav-link"
                                variant="outline-primary"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}
